import Component from '../core/Component';

export default class Sizer extends Component
{
    constructor($element)
    {
        super($element);
    }

    prepare()
    {
        if (document.documentElement.className.indexOf('cms') === -1) {
            // do once
            let image = document.querySelector('[data-product-image]');
            let height = image.offsetHeight;
            let width = image.offsetWidth;
            let ratio = height / width;

            this.$element.attr('width', width);
            this.$element.attr('height', height);
            console.log(ratio);



            let img = new Image();
            img.onload = event => {
                let height = image.offsetHeight;
                let width = image.offsetWidth;
                let ratio = height / width;


                console.log(ratio);
                this.$element.attr('width', width);
                this.$element.attr('height', height);
            }

            const $detailImage = $('.detail__img');
            img.src = image.src;
        }
    }
}


// WEBPACK FOOTER //
// ./components/Sizer.js